var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconDelivery = function SvgIconDelivery(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12.948,
    viewBox: "0 0 13 12.948",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9409",
    "data-name": "Grupo 9409",
    transform: "translate(-124.374 -492.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2205",
    "data-name": "Caminho 2205",
    d: "M12.315.687H10.371a.685.685,0,0,0-.4.131L9.8.949a3.763,3.763,0,0,1-1.179.573A2.271,2.271,0,0,0,6.5,0,2.307,2.307,0,0,0,4.365,1.521,3.763,3.763,0,0,1,3.186.949L3.011.818a.685.685,0,0,0-.4-.131H.685a.689.689,0,0,0-.685.7.689.689,0,0,0,.685.7h1.7A4.93,4.93,0,0,0,4.3,2.945a2.266,2.266,0,0,0,.414.834A3.918,3.918,0,0,0,2.692,7.214v4.45a1.192,1.192,0,0,0,1.179,1.211h.35V10.633A2.326,2.326,0,0,1,6.516,8.278a2.313,2.313,0,0,1,2.278,2.356v2.241h.35a1.192,1.192,0,0,0,1.179-1.211V7.214A3.991,3.991,0,0,0,9.208,4.45,4.118,4.118,0,0,0,8.3,3.779a2.235,2.235,0,0,0,.4-.834,5.037,5.037,0,0,0,1.912-.851h1.7a.689.689,0,0,0,.685-.7A.7.7,0,0,0,12.315.687ZM6.5,1.063A1.278,1.278,0,0,1,7.759,2.356a1.259,1.259,0,1,1-2.517,0A1.278,1.278,0,0,1,6.5,1.063Z",
    transform: "translate(124.374 492.238)",
    fill: "#191750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2206",
    "data-name": "Caminho 2206",
    d: "M34.23,57.1a1.333,1.333,0,0,0-1.33,1.33v3.721a1.33,1.33,0,1,0,2.66,0V58.43A1.344,1.344,0,0,0,34.23,57.1Z",
    transform: "translate(96.644 444.758)",
    fill: "#191750"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconDelivery, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_delivery.58ee6575.svg";
export { ForwardRef as ReactComponent };